module.exports = __webpack_public_path__ + "img/person-square.e8b590cc.svg";